<template>
	<div class="page_content list_question" aria-label="Item List Page Content">

		<div class="row page-heading border-0">
			<div class="col-8 input module_heading">
				<span class="icon-assessment float-left"></span>
				<span class="head_txt ace_sec_txt">Item List</span>
			</div>
			<div class="col-4 submit btn-container text-right">
				<button class="btn btn-primary float-right" id="createItem" @click="$router.push('/item/create')">Create Item</button>
			</div>
		</div>

    <div class="section pad-sml">
			<div class="mt-3 content-section list_container" id="learnosity-author" style="width: calc(100vh - 145px);"></div>
    </div>

	</div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'listItem',
    mounted () {
      this.listLearnosityItem()
    },
    methods: {
      ...mapActions([
        'listItem'
      ]),
      listLearnosityItem () {
        this.listItem(this.$router)
      }
    }
  }
</script>

<style scoped>
  #createItem {
    margin-left: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/app/assessment/components/ListItem.vue